export enum DateSearchStrategy {
  INTERSECTION = 'INTERSECTION',
  STRICT = 'STRICT'
}
